<template>
  <div class="container">
    <div class="head-box">
      <div class="c-flex c_flex_center">
        <h4>报表库</h4>
        <span class="f-s-14 c-m-l-15"></span>
      </div>
      <div class="c-flex">
        <el-input
          placeholder="请输入标题"
          v-model="searchValue"
          clearable
          @clear="
            fpi.page = 1;
            getData();
          "
          @keyup.enter.native="
            fpi.page = 1;
            getData();
          "
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="
              fpi.page = 1;
              getData();
            "
          ></el-button>
        </el-input>
        <el-button type="primary" @click="doNew" class="c-m-l-10">新增报表</el-button>
      </div>
    </div>
    <div class="reports">
      <div class="filter">
        <div class="c-font-500">筛选</div>
        <div class="m-t-20">报表内容</div>
        <el-checkbox-group v-model="bizTypes" class="filter-checkbox" @change="getData">
          <el-checkbox v-for="(item, i) in options.bizTypes" :key="i" :label="item.value">
            {{ item.label }}
          </el-checkbox>
        </el-checkbox-group>
        <div class="m-t-20">报表类型</div>
        <el-checkbox-group v-model="reportType" class="filter-checkbox" @change="getData">
          <el-checkbox v-for="(item, i) in options.reportType" :key="i" :label="item.value">
            {{ item.label }}
          </el-checkbox>
        </el-checkbox-group>
      </div>
      <div class="c-flex-1 c-flex c-flex-col">
        <div class="c-flex c-flex-between" style="padding: 0 30px">
          <span>查询到{{ fpi.total || 0 }}个报表</span>
          <el-switch
            v-model="notAdded"
            active-text="仅展示未加入看板的报表"
            @change="getData"
          ></el-switch>
        </div>
        <div class="c-flex-1" style="overflow-y: auto; padding-bottom: 300px">
          <grid-layout
            :layout.sync="layout"
            :col-num="2"
            :row-height="550"
            :is-draggable="false"
            :is-resizable="false"
            :static="true"
            :is-mirrored="false"
            :vertical-compact="true"
            :margin="[20, 20]"
            :use-css-transforms="true"
            :responsive="false"
            :cols="{ lg: 2, md: 2, sm: 2, xs: 1, xxs: 1 }"
            @layout-updated="renderCharts(layout)"
          >
            <grid-item
              v-for="item in layout"
              :x="item.x"
              :y="item.y"
              :w="item.w"
              :h="item.h"
              :i="item.i"
              :key="item.i"
            >
              <div class="report c-flex c-flex-col" style="box-sizing: border-box; height: 100%">
                <div class="report-info">
                  <h3>{{ item.report.name }}</h3>
                  <div class="report-btns">
                    <el-button
                      plain
                      round
                      type="primary"
                      size="small"
                      @click="
                        add.formData = $util.deepCopy(item);
                        add.show = true;
                      "
                    >
                      添加到看板
                    </el-button>
                    <el-button
                      plain
                      round
                      type="danger"
                      size="small"
                      @click="removeFrom(item.report)"
                      v-if="false && addedReports.indexOf(item.report._id) != -1"
                    >
                      从所有看板移除
                    </el-button>
                    <template v-if="osg.has('ReportPalette,operation')">
                      <el-button
                        plain
                        round
                        type="primary"
                        size="small"
                        @click="doEdit(item.report)"
                      >
                        编辑
                      </el-button>
                      <el-button
                        round
                        type="danger"
                        size="small"
                        @click="doEnable(item.report._id)"
                        v-if="item.report.state == 0"
                      >
                        已禁用
                      </el-button>
                      <el-button
                        round
                        type="success"
                        size="small"
                        @click="doDisable(item.report._id)"
                        v-else
                      >
                        已启用
                      </el-button>
                      <el-button
                        plain
                        round
                        type="danger"
                        size="small"
                        @click="doRemove(item.report)"
                      >
                        删除
                      </el-button>
                    </template>
                  </div>
                  <!-- <div class="report-question">{{ item.report.question }}</div> -->
                  <div class="report-memo" :title="item.report.memo">
                    {{ item.report.memo }}
                  </div>
                </div>
                <report-filter
                  v-if="!openDetail"
                  :params="JSON.parse(item.report.params)"
                  @getPalette="getPalette(item.report, $event)"
                ></report-filter>
                <div class="report-html" :id="item.report._id" :ref="item.report._id">
                  <div v-html="item.report.modeResult" class="report-modeResult"></div>
                  <!-- <cReportLit
                    :reportData="item.report"
                    v-if="item.report.reportType == 'table'"
                  ></cReportLit> -->
                </div>
              </div>
            </grid-item>
          </grid-layout>
        </div>
      </div>
    </div>
    <el-dialog title="报表" :visible.sync="openDetail">
      <el-form
        :model="formData"
        :rules="rules"
        ref="formData"
        label-width="110px"
        label-position="left"
      >
        <el-form-item
          label="名称"
          prop="name"
          :rules="{
            required: true,
            trigger: 'blur',
            message: '请填写'
          }"
        >
          <el-input v-model="formData.name"></el-input>
        </el-form-item>
        <!-- <el-form-item label="问题" prop="question">
          <el-input v-model="formData.question"></el-input>
        </el-form-item> -->
        <el-form-item label="描述" prop="memo">
          <el-input v-model="formData.memo" type="textarea" :rows="2"></el-input>
        </el-form-item>
        <el-form-item label="报表唯一标识" prop="code">
          <el-input v-model="formData.code"></el-input>
        </el-form-item>
        <el-form-item label="统计定义">
          <el-select v-model="formData.reportDefId" clearable>
            <el-option
              v-for="item in options.reportDef"
              :key="item._id"
              :label="item.name"
              :value="item._id"
              @click.native="reportDefChange(item.colFrom)"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="集合名称"
          prop="colName"
          :rules="{
            required: true,
            trigger: 'blur',
            message: '请填写'
          }"
        >
          <el-input v-model="formData.colName"></el-input>
        </el-form-item>
        <el-form-item
          label="统计模式"
          prop="reportMode"
          :rules="{
            required: true,
            trigger: 'blur',
            message: '请选择'
          }"
        >
          <el-radio-group v-model="formData.reportMode">
            <el-radio :label="Number(item.value)" v-for="(item, i) in options.reportMode" :key="i">
              {{ item.label }}
            </el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="报表内容">
          <el-select v-model="formData.bizTypes" multiple>
            <el-option
              v-for="item in options.bizTypes"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="报表类型">
          <el-select v-model="formData.reportType">
            <el-option
              v-for="item in options.reportType"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="参数定义">
          <el-input
            v-model="formData.params"
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 6 }"
          ></el-input>
        </el-form-item>
        <el-form-item label="数据集定义">
          <el-input
            v-model="formData.dataset"
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 6 }"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="图表模式"
          :rules="{
            required: true,
            trigger: 'blur',
            message: '请选择'
          }"
        >
          <el-select v-model="formData.mode">
            <el-option
              v-for="item in options.paletteMode"
              :key="item.value"
              :label="item.label"
              :value="Number(item.value)"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="前置脚本">
          <el-input
            v-model="formData.preScript"
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 6 }"
            placeholder="主要用于页面参数处理，可用于数据集引用"
          ></el-input>
        </el-form-item>
        <el-form-item label="中置脚本">
          <el-input
            v-model="formData.midScript"
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 6 }"
            placeholder="主要用于数据集数据处理，为后续生成输出结果"
          ></el-input>
        </el-form-item>
        <el-form-item label="后置脚本">
          <el-input
            v-model="formData.postScript"
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 6 }"
            placeholder="主要用于输出结果处理"
          ></el-input>
        </el-form-item>
        <el-form-item label="数据输出配置">
          <el-input
            v-model="formData.modeResultCfg"
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 6 }"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button type="primary" @click="doSave">确 定</el-button>
        <el-button @click="doInit">取 消</el-button>
      </div>
    </el-dialog>
    <el-dialog title="添加到看板" :visible.sync="add.show">
      <el-form
        :model="add.formData"
        :rules="rules"
        ref="addformData"
        label-width="70px"
        label-position="top"
        hide-required-asterisk
      >
        <el-form-item label="将此报表添加到哪个看板？">
          <el-select v-model="add.dashboard">
            <el-option
              v-for="item in options.dashboard"
              :key="item.value"
              :label="item.label"
              :value="item"
              :disabled="item.addedReports.indexOf(add.show && add.formData.report._id) != -1"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button type="primary" @click="addTo">确 定</el-button>
        <el-button
          @click="
            add.show = false;
            add.formData = {};
            add.dashboard = {};
          "
        >
          取 消
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import VueGridLayout from 'vue-grid-layout';
// import cReportLit from '../../components/reportList.vue';
import Vue from 'vue';
let echarts = require('echarts');
export default {
  activated() {
    window.$this = this;
  },
  components: {
    GridLayout: VueGridLayout.GridLayout,
    GridItem: VueGridLayout.GridItem
    // cReportLit
  },
  data() {
    window.$this = this;
    let that = this;
    return {
      chart: echarts,
      tenantId: '',
      layout: [],
      openDetail: false,
      formData: { colName: '' },
      rules: that.$util.rules,
      fpi: {},
      searchValue: '',
      globalDate: [], //全局时间筛选
      options: {
        codecfg_reportType: { codeId: 'reportType' },
        codecfg_bizTypes: { codeId: 'reportBizTypes' },
        codecfg_dateRangeType: { codeId: 'DATERANGETYPE' },
        codecfg_reportMode: { codeId: 'reportMode' },
        codecfg_paletteMode: { codeId: 'paletteMode' },
        reportDefId: []
      },
      addedReports: [], //所有已添到看板的报表
      notAdded: false, //筛选 是否仅展示未添加的报表
      bizTypes: [], //筛选 报表内容
      reportType: [], //筛选 报表展示类型
      //将此报表添加到指定看板
      add: {
        formData: {},
        dashboard: {},
        show: false
      },
      //从所有看板移除此报表
      remove: {
        formData: {},
        show: false
      },
      //当前页面各报表块数据
      reports: {},
      refresh: true,
      currentComp: '',
      content: ''
    };
  },
  mounted() {
    this.tenantId = JSON.parse(sessionStorage['entity']).tenantId;
    this.doInit();
    this.osg.codeoption(() => {
      this.$forceUpdate();
      this.getDashboard();
      this.getReportDef();
    });
  },
  computed: {
    dynComponent() {
      const template = this.content ? this.content : '<div>nothing here yet</div>';
      return {
        template, // use content as template for this component
        props: this.$options.props // re-use current props definitions
      };
    }
  },
  methods: {
    doInit() {
      this.openDetail = false;
      this.formData = { colName: '' };
    },
    getData() {
      let params = {
        page: this.fpi.page,
        rows: this.fpi.rows,
        _all: '1',
        'in:state|array-integer#and': '0,1',
        'regex:name|string#and': this.searchValue, //标题搜索
        'in:bizTypes|array#and': this.bizTypes.toString(), //报表内容筛选
        'in:reportType|array#and': this.reportType.toString() //报表类型筛选
      };
      //仅展示未添加到看板的报表
      if (this.notAdded) {
        params['nin:_id|string#and'] = this.addedReports;
      }
      this.osg.ajax(
        'biz/reportPalette/query.do',
        params,
        res => {
          let layout = [];
          for (let i = 0; i < res.data.length; i++) {
            let item = res.data[i];
            item.params = JSON.stringify(item.params);
            item.dataset = JSON.stringify(item.dataset);
            let obj = {
              x: i % 2,
              y: Math.floor(i / 2),
              w: 1,
              h: 1,
              i: item._id,
              report: item
            };
            layout.push(obj);
          }
          this.layout = layout;
          this.fpi = res;
          this.renderCharts(layout);
        },
        { noload: true }
      );
    },
    // 渲染所有报表块的图表
    renderCharts(layout) {
      this.$nextTick(() => {
        for (let item of layout) {
          this.getPalette(item.report);
        }
      });
    },
    getPalette(report, params) {
      params = params || report.params;
      let obj = { code: report.code };
      if (this.$util.isJson(params)) {
        params = JSON.parse(params);
      }
      if (Array.isArray(params)) {
        for (let item of params) {
          if (item.type == '2') {
            obj[item.name] = item.defaultvalue.join(',');
          } else {
            obj[item.name] = item.defaultvalue;
          }
        }
      }
      this.osg.ajax('biz/reportPalette/getPalette.do', obj, res => {
        let that = this;
        let modeResult = res.modeResult;
        if (report.mode == 2) {
          try {
            if (this.osg.isJson(modeResult)) {
              this.chart
                .init(document.getElementById(report._id))
                .setOption(JSON.parse(modeResult));
            } else {
              var options = {};
              eval(modeResult);
              this.chart.init(document.getElementById(report._id)).setOption(options);
            }
          } catch (e) {
            console.log('报错看板：' + report.name);
            console.log('报错内容：' + e.toString());
            console.log('报错看板对象：', report);
            console.log('-------------------');
          }
        } else {
          let elId = `id${report._id}`;
          modeResult = `<div id="${elId}" style="height:100%">${modeResult}</div>`;
          report.modeResult = modeResult;
          this.$nextTick(() => {
            var res = Vue.compile(modeResult);
            new Vue({
              el: '#' + elId,
              data: {},
              render: res.render,
              staticRenderFns: res.staticRenderFns
            });
          });
        }
      });
    },
    doNew() {
      this.doInit();
      this.openDetail = true;
      this.$nextTick(() => {
        this.$refs['formData'].clearValidate();
      });
    },
    doEdit(item) {
      this.formData = item;
      this.openDetail = true;
      this.$nextTick(() => {
        this.$refs['formData'].clearValidate();
      });
    },
    doSave() {
      let params = this.$util.deepCopy(this.formData);
      if (this.formData.params) {
        if (this.$util.isJson(this.formData.params)) {
          params.params = JSON.parse(this.formData.params);
        } else {
          this.osg.toast('参数定义格式输入不正确！', 'warning');
          return;
        }
      }
      if (this.formData.dataset) {
        if (this.$util.isJson(this.formData.dataset)) {
          params.dataset = JSON.parse(this.formData.dataset);
        } else {
          this.osg.toast('数据集定义格式输入不正确！', 'warning');
          return;
        }
      }
      if (this.osg.validate()) {
        this.osg.ajax(
          'biz/reportPalette/upsert.do',
          { data: JSON.stringify(params) },
          () => {
            this.osg.toast('保存成功');
            if (this.formData._id) {
              this.getPalette(this.formData);
              this.doInit();
            } else {
              this.doInit();
              this.getData();
            }
          },
          { noload: true }
        );
      }
    },
    //平台管理员功能 启用、禁用、删除
    doEnable(id) {
      this.osg.ajax(`biz/reportPalette/enable/${id}.do`, null, () => {
        this.getData();
        this.osg.toast('操作成功！');
      });
    },
    doDisable(id) {
      this.osg.ajax(`biz/reportPalette/disable/${id}.do`, null, () => {
        this.getData();
        this.osg.toast('操作成功！');
      });
    },
    doRemove(item) {
      this.osg.confirm(`是否从报表库删除报表"${item.name}"？`, () => {
        this.osg.ajax(`biz/reportPalette/remove/${item._id}.do`, null, () => {
          this.osg.toast('删除成功');
          this.getData();
        });
      });
    },
    //租户功能 将此报表添加到指定看板
    addTo() {
      let dashboard = this.$util.deepCopy(this.add.dashboard);
      let reports = dashboard.reports || [];
      let maxY = 0;
      for (let item of reports) {
        if (item.report.y > maxY) maxY = item.report.y;
      }
      let obj = {
        x: 0,
        y: maxY + 1,
        w: 1,
        h: 1,
        i: this.add.formData.report._id,
        report: this.add.formData.report
      };
      dashboard.reports.push(obj); //将添加到看板的报表id插入addedReports
      //编辑平台预置看板 新增看板
      if (dashboard.tenantId == '0' && this.tenantId != '0') {
        dashboard.tenantId = this.tenantId;
        dashboard.sourceId = dashboard._id;
        dashboard._id = '';
      }
      dashboard.exts.type = 2; //新的是2
      this.osg.ajax(
        'biz/dashboard/upsert.do',
        { dashboard: JSON.stringify(dashboard) },
        () => {
          //将当前报表id插入到整体addedReports
          this.addedReports.push(this.add.formData.report._id);
          //将当前报表id插入到添加到的看板的addedReports
          for (let item of this.options.dashboard) {
            if (dashboard._id == item._id) {
              item.addedReports.push(this.add.formData.report._id);
              break;
            }
          }
          this.add = {
            formData: {},
            dashboard: {},
            show: false
          };
          this.getDashboard();
          this.osg.toast('已添加到看板');
        },
        { noload: true }
      );
    },
    //租户功能 将此报表从所有看板移除
    removeFrom(row) {
      this.osg.confirm(
        `是否从所有看板中删除报表"${row.name}"？该报表将保留在您的报表库中，并且可以随时添加回看板。`,
        () => {
          this.osg.ajax('', null, res => {
            this.osg.toast('删除成功');
          });
        }
      );
    },
    //获取所有可查看看板，收集已经加入看板的reportId
    getDashboard() {
      this.osg.ajax(
        'biz/dashboard/query.do',
        {
          'is:exts.type|integer#and': 2
        },
        res => {
          let addedReports = [];
          res.data.map(item => {
            item.label = item.boardName;
            item.value = item._id;
            item.reports = item.reports || [];
            item.addedReports = [];
            for (let report of item.reports) {
              item.addedReports.push(report.report._id);
              addedReports.push(report.report._id);
            }
          });
          this.addedReports = addedReports;
          this.options.dashboard = res.data;
          this.getData();
        },
        { noload: true }
      );
    },
    getReportDef() {
      let params = {
        page: this.fpi.page,
        rows: this.fpi.rows,
        'in:state|array-integer#and': '0,1',
        'regex:name|string#or': this.searchValue,
        'regex:memo|string#or': this.searchValue,
        'regex:code|string#or': this.searchValue,
        'regex:colFrom|string#or': this.searchValue,
        sortField: 'updateTime',
        sortOrder: 'desc'
      };
      this.osg.ajax('biz/reportDef/query.do', params, res => {
        this.options.reportDef = res.data;
      });
    },
    reportDefChange(colFrom) {
      this.formData.colName = colFrom;
      this.$forceUpdate();
    },
    /**
     * 树图渲染
     */
    getLevelOption() {
      return [
        {
          itemStyle: {
            borderColor: '#777',
            borderWidth: 0,
            gapWidth: 1
          },
          upperLabel: {
            show: false
          }
        },
        {
          itemStyle: {
            borderColor: '#555',
            borderWidth: 5,
            gapWidth: 1
          },
          emphasis: {
            itemStyle: {
              borderColor: '#ddd'
            }
          }
        },
        {
          colorSaturation: [0.35, 0.5],
          itemStyle: {
            borderWidth: 5,
            gapWidth: 1,
            borderColorSaturation: 0.6
          }
        }
      ];
    },
    colorMappingChange(value) {
      let levelOption = this.getLevelOption(value);
      this.chart.setOption({
        series: [
          {
            levels: levelOption
          }
        ]
      });
    }
  }
};
</script>
<style scoped>
.el-radio {
  display: inherit !important;
}
.container {
  margin: -10px -20px;
  height: calc(100% + 20px);
  background: #f5f8fa;
  overflow: hidden;
}
.head-box {
  background: #fff;
  padding: 0 10px;
  border-top: 1px solid #dfe3eb;
}
.reports {
  display: flex;
  padding: 20px;
  box-sizing: border-box;
  overflow: hidden;
  flex: 1;
}
.vue-grid-item {
  border-radius: 3px;
  background-color: #fff;
  cursor: grab !important;
  transition: box-shadow 0.15s ease-in-out;
  overflow: hidden;
}
.vue-grid-item:hover {
  box-shadow: 0 1px 20px 0 rgba(0, 0, 0, 0.1);
}
.filter {
  padding: 0 20px;
}
.filter-checkbox > label {
  display: block;
  padding: 10px;
  margin-right: 0;
  flex-direction: row;
}
.report {
  padding: 20px;
}
.report-info {
  height: 120px;
  overflow: hidden;
}
.report-btns {
  padding: 12px 0;
}
.report-question {
  font-weight: 500;
  padding: 20px 0 10px;
}
.report-memo {
  opacity: 0.8;
  overflow: hidden;
  position: relative;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  box-sizing: border-box;
  font-size: 14px;
}
.report-html {
  width: 100%;
  flex: 1;
  overflow: auto;
}
.report-modeResult {
  width: 100%;
  height: 100%;
  overflow: auto;
}
</style>
